import { render, staticRenderFns } from "./settings-lists-works.vue?vue&type=template&id=7cc01948&"
import script from "./settings-lists-works.ts?vue&type=script&lang=ts&"
export * from "./settings-lists-works.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports